import { render } from "./ClinicOperatingInfo.vue?vue&type=template&id=de81b74a&scoped=true&ts=true"
import script from "./ClinicOperatingInfo.vue?vue&type=script&lang=ts"
export * from "./ClinicOperatingInfo.vue?vue&type=script&lang=ts"

import "./ClinicOperatingInfo.vue?vue&type=style&index=0&id=de81b74a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de81b74a"]])

export default __exports__